import type {
  IVideoCategory,
  IVideoCreate,
  IVideoResultCreate,
  IVideoResultItem,
  IVideoTagResultItem,
  IVideoUpdate,
  VIDEO_CATEGORIES,
} from '~/types/video'

import config from '~/config'
import { request } from '~/utils/request'

type QueryParams = {
  category?: VIDEO_CATEGORIES
  p?: number
  q?: string
  size?: number
}

export const listVideo = (params: QueryParams): Promise<IPaginatedResponse<IVideoResultItem>> => {
  return request({
    params,
    url: `${config.SERVICES_API}/video`,
  })
}

export const listUserVideo = (params: QueryParams = {}): Promise<IPaginatedResponse<IVideoResultItem>> => {
  return request({
    params,
    url: `${config.SERVICES_API}/video-user`,
  })
}

export const createVideo = (data: IVideoCreate): Promise<IVideoResultCreate> => {
  return request({
    data: data,
    method: 'POST',
    url: `${config.SERVICES_API}/video`,
  })
}

export const getVideoById = (id: string): Promise<IVideoResultItem> => {
  return request({
    url: `${config.SERVICES_API}/video/${id}`,
  })
}

export const updateVideo = ({ category, description, id, tags, title }: IVideoUpdate): Promise<void> => {
  return request({
    data: {
      category,
      description,
      tags,
      title,
    },
    method: 'PATCH',
    url: `${config.SERVICES_API}/video/${id}`,
  })
}

export const updateVideoThumbnail = ({ fileId, id }: { fileId: string; id: string }): Promise<void> => {
  return request({
    data: { file_id: fileId },
    method: 'PATCH',
    url: `${config.SERVICES_API}/video/${id}/thumbnail`,
  })
}

export const listAllVideoTag = (): Promise<IOption[]> => {
  return request({
    url: `${config.SERVICES_API}/video-tag`,
  })
}

export const addVideoToFavourite = (data: { videoId: string }): Promise<IVideoTagResultItem[]> => {
  return request({
    data: { video_id: data.videoId },
    method: 'POST',
    url: `${config.SERVICES_API}/video-user`,
  })
}

export const deleteVideoFromFavourite = (data: { videoId: string }): Promise<IVideoTagResultItem[]> => {
  return request({
    data: { video_id: data.videoId },
    method: 'DELETE',
    url: `${config.SERVICES_API}/video-user`,
  })
}

export const listAllVideoCategories = (): Promise<IVideoCategory[]> => {
  return request({
    url: `${config.SERVICES_API}/video/category`,
  })
}
